"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Input = _interopRequireDefault(require("../Input"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _Search = _interopRequireDefault(require("../Icons/Search"));

var _Cross = _interopRequireDefault(require("../Icons/Cross"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex !important;\n\talign-items: center;\n\tmax-width: 300px;\n\tpadding: 4px 4px 4px ", ";\n\tmargin: ", " 0;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tborder: 2px solid ", ";\n\tborder-radius: 4px;\n\tsvg {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: 2px;\n\tpadding: ", ";\n\n\t", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: ", " !important;\n\tmin-height: ", " !important;\n\tflex: 1;\n\toverflow: auto;\n\tmargin: 0 !important;\n\tborder: 0 !important;\n\toutline: 0;\n\tvertical-align: middle;\n\t&:hover,\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var InputField = (0, _styledComponents.default)(_Input.default)(_templateObject(), _spacing.default.s4, _spacing.default.s4);
InputField.displayName = 'InputField';
var CrossIcon = (0, _styledComponents.default)(_Cross.default)(_templateObject2(), _spacing.default.s1, function (_ref) {
  var filter = _ref.filter;
  return filter ? "color: " + _colors.default.primaryDarker + ";\n\t\t\tbackground-color: " + _colors.default.bodyBackground + ";\n\t\t\tcursor: pointer;\n\t\t\t&:hover {\n\t\t\t\tcolor: white;\n\t\t\t\tbackground-color: " + _colors.default.primaryDark + ";\n\t\t\t}" : "color: lightgrey;\n\t\t\tbackground-color: " + _colors.default.disabledBackground + ";";
});
CrossIcon.displayName = 'CrossIcon';

var Container = _styledComponents.default.div(_templateObject3(), _spacing.default.s1, _spacing.default.s1, _colors.default.borderColor);

Container.displayName = 'Container';

var SearchInput = function SearchInput(_ref2) {
  var _onChange = _ref2.onChange,
      value = _ref2.value,
      placeholder = _ref2.placeholder,
      rest = _objectWithoutPropertiesLoose(_ref2, ["onChange", "value", "placeholder"]);

  return _react.default.createElement(Container, rest, _react.default.createElement(_Search.default, {
    size: 16,
    color: _colors.default.borderColor,
    style: {
      verticalAlign: 'middle'
    }
  }), _react.default.createElement(InputField, {
    onChange: function onChange(_ref3) {
      var newValue = _ref3.currentTarget.value;

      _onChange(newValue);
    },
    value: value,
    placeholder: placeholder,
    "data-testid": "filter-input"
  }), _react.default.createElement(CrossIcon, {
    filter: value,
    size: 32,
    onClick: function onClick() {
      return _onChange('');
    },
    "data-testid": "clear-button"
  }));
};

SearchInput.propTypes = {
  onChange: _propTypes.func.isRequired,
  value: _propTypes.string.isRequired,
  placeholder: _propTypes.string
};
SearchInput.defaultProps = {
  placeholder: ''
};
var _default = SearchInput;
exports.default = _default;